// extracted by mini-css-extract-plugin
export default {"title":"Cars_title__Ff1NE"};